import {} from "../half-edge/index.js";
import {} from "./Net.js";
export function findHalfEdgeEntry(net, halfEdge) {
    return net.halfEdgeEntries.get(halfEdge.id);
}
//# sourceMappingURL=findHalfEdgeEntry.js.map